module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-a76116de1780f36e7a607b7e94f918ee.webp";